// extracted by mini-css-extract-plugin
export default {"container":"profile_container__kYDsQ","aside":"profile_aside__FdroU","section":"profile_section__1bXNe"};